(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('VoucherSaleConfirmationDeleteController',VoucherSaleConfirmationDeleteController);

    VoucherSaleConfirmationDeleteController.$inject = ['$uibModalInstance', 'entity', 'VoucherSaleConfirmation'];

    function VoucherSaleConfirmationDeleteController($uibModalInstance, entity, VoucherSaleConfirmation) {
        var vm = this;

        vm.voucherSaleConfirmation = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            VoucherSaleConfirmation.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
